export default __webpack_public_path__ + "static/media/property_946.270fc52e.png";